import React, {Component, PropTypes} from 'react';
import {versionCheckInterval} from 'app/globals';
import * as AppRepository from 'modules/app/repositories/AppRepository';
import './style.scss';

class VersionCheck extends Component {

    state = {
        hash: null,
        hashChanged: false
    };

    componentWillMount() {
        this.iv = setInterval(this.refreshState, versionCheckInterval());
    }

    refreshState = () => {
        AppRepository.getStats()().then(stats => {
            const hash = stats.files['main.js'];
            if (this.state.hash && this.state.hash !== hash) {
                this.setState({hash: hash, hashChanged: true});
                clearInterval(this.iv);
            } else {
                this.setState({hash: hash});
            }
        });
    };

    refreshBrowser = (e) => {
        e.preventDefault();
        window.location.reload(true);
    };

    render() {

        if (this.state.hashChanged) {
            return (
                <div className="version-check">A new version of Fast Gate is available.
                    <a href="#" onClick={this.refreshBrowser}>Please refresh your browser.</a>
                </div>
            );
        }

        return null;
    }
}

export default VersionCheck;
